export const roles = {
    SUPER_ADMIN: 'ROLE_SUPER_ADMIN',
    SECRETARY: 'ROLE_SECRETARY',
    DIRECTOR: 'ROLE_DIRECTOR',
    DIRECTOR_OF_STUDIES: 'ROLE_DIRECTOR_OF_STUDIES',
    PROFESSOR: 'ROLE_PROFESSOR',
    PROFESSOR_COORDINATOR: 'ROLE_PROFESSOR_COORDINATOR',
    MARKETING_MANAGER: 'ROLE_MARKETING_MANAGER',
    DESIGNER: 'ROLE_DESIGNER',
    STUDENT: 'ROLE_STUDENT',
    GUARDIAN: 'ROLE_GUARDIAN'
};